/* eslint-disable */
import logo from '../../assets/img/logo/logo_bright.webp';
import dark_logo from '../../assets/img/logo/logo_grey_dark_small.webp';

export const config = {
	api_url: process.env.REACT_APP_URL_API,
};


export const general = {
	logo: logo,
	dark_logo: dark_logo,
};

const exportedObject = {
	general,
	config,
};

export default exportedObject;
